import React, { Component } from 'react'
import { Translate } from 'react-localize-redux';
import { Grid, List, ListItem, ListItemIcon, ListItemText,  Typography } from '@mui/material';
import PropTypes from 'prop-types';
import Table from '../../general/table';
import DataCollection from './data_collection';
import { ButtonContinue, ButtonAdd, ButtonBack } from '../../general/mini_components';  
import { EnhancedTable } from '../../general/EnhancedTable';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import OrderableTable from '../../general/OrderableTable';
/**
 * An EDC is a collection of data_collections
 */

const SECTION_FORM = {
    "name" : {
        required : true,
        type:"text",
        label:"investigation.create.edc.data_collections.title",
        shortLabel: "investigation.create.edc.data_collections.title",
        validation : "textMin2"
    },
    "repeats":{
        required : false,
        type:"checkbox",
        label:"investigation.create.edc.repeats",
        shortLabel: "investigation.create.edc.repeats",
        validation : "notEmpty"
    }
}

/**
 * SHER-332: reorder surveys using the DISPLAYED (order-sorted) positions the drag indices refer
 * to — not positions in the raw array, whose order doesn't match `order` (the API returns surveys
 * without ORDER BY). Returns a new array with `order` renumbered 0..n to match the new display
 * order, so array order and `order` stay in sync afterwards.
 */
export function reorderSurveysByDisplay(surveys, sourceIndex, destinationIndex){
    const ordered = (surveys || []).filter(Boolean).sort((a, b) => (a?.order ?? 0) - (b?.order ?? 0));
    const [removed] = ordered.splice(sourceIndex, 1);
    ordered.splice(destinationIndex, 0, removed);
    return ordered.map((survey, index) => ({ ...survey, order: index }));
}

export default class EDC extends Component{
    constructor(props){
        super(props);

        this.toggleAddDataCollection = this.toggleAddDataCollection.bind(this);
        //this.renderNewDataCollectionForm = this.renderNewDataCollectionForm.bind(this);
        this.renderDataCollections = this.renderDataCollections.bind(this);
        this.closeNewDataCollection = this.closeNewDataCollection.bind(this);
        this.submitData = this.submitData.bind(this);
        this.callBackNewDataCollection = this.callBackNewDataCollection.bind(this);
        this.toggleOrder = this.toggleOrder.bind(this);
        const initialState = {surveys: [], addingDataCollection:false, editingIndexDataCollection:false, ordering:false}
        this.state = props.initialData ? Object.assign({}, initialState, props.initialData) : initialState;
    }
    getItemStyle(isDragging, draggableStyle){
        // styles we need to apply on draggables
        return {...draggableStyle,
            ...(isDragging && {
            background: "rgb(235,235,235)"
        })}
    }
    getListStyle(isDraggingOver){
        //background: isDraggingOver ? 'lightblue' : 'lightgrey',
    }
    
    orderUpdate(dragDrop){
        this.setState({ surveys: reorderSurveysByDisplay(this.state.surveys, dragDrop.source.index, dragDrop.destination.index) });
    }
    renderDataCollections(){
        const AddButton= <ButtonAdd disabled={this.state.addingDataCollection || Number.isInteger(this.state.editingIndexDataCollection)} 
                            type="button" data-testid="add_data_collections" show={!this.state.addingDataCollection}  
                            onClick={this.toggleAddDataCollection}></ButtonAdd>
        if(this.state.surveys.length === 0){
            return (<Grid item xs={12}>
                { AddButton }
                <Typography variant="body2" gutterBottom component="span">
                    <Translate id="investigation.create.edc.data_collections.none" />
                </Typography>
                
            </Grid>)
        }
        
        const headCells =[{ id:"title", alignment: "left", label: <Translate id="investigation.create.edc.data_collections.name" />}, 
                            {id:"number_sections", alignment: "left", label: <Translate id="investigation.create.edc.data_collections.number_sections" />},
                            {id:"type", alignment: "left", label: <Translate id="investigation.create.edc.data_collections.type" />},
                            {id:"category", alignment: "left", label: <Translate id="investigation.create.edc.data_collections.category" />}
                        ]
        
        // SHER-332: the row id must be the survey's index in the UNSORTED state.surveys array,
        // because editDataCollection/deleteDataCollection index into that array. Sorting by `order`
        // for display (the API returns surveys without ORDER BY, so array order != order field)
        // would otherwise make edit/delete hit surveys[displayedIndex] — a DIFFERENT survey
        // (Pedro: editing "Test" opened "Kinésithérapie", the one below).
        const rows = this.state.surveys
            .map((survey, originalIndex) => ({ survey, originalIndex }))
            .filter((item) => Boolean(item.survey))
            .sort((a, b) => (a.survey?.order ?? 0) - (b.survey?.order ?? 0))
            .map(({ survey, originalIndex }) => {
                return { id : originalIndex, title : survey.name, number_sections : survey.sections.length, type : survey.type, category : survey.category};
            })
            
        if(!this.state.reordering){
            return([
                <Grid item xs={12}>
                    <OrderableTable onDragEnd={(result) => this.orderUpdate(result)} 
                        orderUpdate={(result) => this.orderUpdate(result)} noSelectable 
                        droppableId="edc"
                        titleTable={<Translate id="investigation.create.edc.data_collections.title" />} rows={rows} headCells={headCells} 
                        actions = {[{"type" : "delete", "func" : (index) => this.deleteDataCollection(index)}, {"type" : "edit", "func" : (index) => this.editDataCollection(index)}]} 
                        />
                </Grid>,
                <Grid item xs={12}>
                    {AddButton}
                    <Typography variant="body2" gutterBottom component="span">
                        <Translate id="investigation.create.edc.data_collections.new" />
                    </Typography> 
                </Grid>
            ]
            )
        }
    }
    toggleAddDataCollection(){
        let tempState = {...this.state};
        tempState.addingDataCollection = !tempState.addingDataCollection;
        this.setState(tempState);
    }
    deleteDataCollection(index){
        let tempState = {...this.state};
        tempState.addingDataCollection = false;
        tempState.editingIndexDataCollection = false;
        tempState.surveys.splice(index, 1);
        this.setState(tempState);
    }
    editDataCollection(index, element){
        console.log("Edit DataCollection", index);
        let tempState = {...this.state};
        tempState.addingDataCollection = true;
        tempState.editingIndexDataCollection = index;
        this.setState(tempState);
    }
    callBackNewDataCollection(dataCollection){
        console.log("New section!", dataCollection);
        let tempState = {...this.state};
        tempState.addingDataCollection = false;
        tempState.editingIndexDataCollection = false;
        if(Number.isInteger(this.state.editingIndexDataCollection)){
            tempState.surveys[this.state.editingIndexDataCollection] = dataCollection;
        }
        else{
            tempState.surveys.push(dataCollection);
        }
        
        this.setState(tempState);

    }
    closeNewDataCollection(){
        console.log("closeNewDataCollection");
        let tempState = {...this.state};
        tempState.addingDataCollection = false;
        tempState.editingIndexDataCollection = false;
        this.setState(tempState);
    }
    // renderNewDataCollectionForm(){
    //     console.log("renderNewDataCollectionForm");
    //     const staticParams = {
    //         callBackNewDataCollection:this.callBackNewDataCollection,
    //         closeNewDataCollection:this.closeNewDataCollection
    //     }
    //     if(this.state.addingDataCollection){
    //         return (<DataCollection {...staticParams} />);
    //     }
    //     else if(Number.isInteger(this.state.editingIndexDataCollection)){
    //         return (<DataCollection initialData={this.state.surveys[this.state.editingIndexDataCollection]} 
    //                     {...staticParams}
    //                 />);
    //     }
    //     else{
    //         return null;
    //     }
    // }
    submitData(){
        this.props.callBackData({surveys : this.state.surveys});
    }
    toggleOrder(){
        const tempState = {...this.state};
        tempState.reordering = !tempState.reordering;
        this.setState(tempState);
    }
    render(){
        
        if(this.state.addingDataCollection){
            return <DataCollection initialData={this.state.surveys[this.state.editingIndexDataCollection]} 
                        departments={this.props.initialData.departments}
                        callBackData={this.callBackNewDataCollection} callBackStepBack={() => {this.toggleAddDataCollection()}}/>
        }
        else{
            return (
                <Grid container spacing={3}>    
                    { this.renderDataCollections() }
                    <Grid item xs={12}>
                        {
                            this.props.callBackStepBack && 
                            <ButtonBack spaceright={1} data-testid="back" onClick={this.props.callBackStepBack} ><Translate id="general.back"/></ButtonBack>
                        }
                        <ButtonContinue data-testid="save_surveys" disabled={this.state.surveys.length === 0} 
                            type="button" onClick={this.submitData}>
                                <Translate id="investigation.create.continue" />
                        </ButtonContinue>
                    </Grid>
                </Grid>
            )
        }
    }
}


EDC.propTypes = {
    initialData: PropTypes.object,
    callBackData: PropTypes.func.isRequired
};


